import React from 'react';
import styled, { keyframes } from 'styled-components';

interface LoadingSpinnerProps {
  size?: number;
  color?: string;
  fullScreen?: boolean;
  message?: string;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ 
  size = 48, 
  color = 'var(--Primary-Strong, #296768)',
  fullScreen = false,
  message = ''
}) => {
  if (fullScreen) {
    return (
      <FullScreenContainer>
        <Spinner size={size} color={color} />
        {message && <LoadingMessage>{message}</LoadingMessage>}
      </FullScreenContainer>
    );
  }

  return (
    <Container>
      <Spinner size={size} color={color} />
      {message && <LoadingMessage>{message}</LoadingMessage>}
    </Container>
  );
};

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const FullScreenContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  gap: 16px;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 40px 0;
  gap: 16px;
`;

const Spinner = styled.div<{ size: number; color: string }>`
  width: ${props => props.size}px;
  height: ${props => props.size}px;
  border-radius: 50%;
  border: 4px solid #f3f3f3;
  border-left: 4px solid ${props => props.color};
  animation: ${spin} 1s linear infinite;
`;

const LoadingMessage = styled.div`
  color: var(--Label-Alternative, rgba(55, 56, 60, 0.61));
  font-size: 16px;
  font-family: 'Pretendard JP', sans-serif;
  font-weight: 400;
  line-height: 24px;
`;

export default LoadingSpinner;
